export default "/static/dashboard/build/app/img/v2/cef6dbc4dcdfd43317e36f64a2a94ea4.png";